export default __webpack_public_path__ + "static/hero-landscape-small-1070x602-c38131000d462b24510c2d0b23a99d42.mp4";